/**
 * BrewNectar Hero — scroll-triggered fade-up animations and smooth CTA anchor scroll
 */
(function () {
  'use strict';

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function initHero(section) {
    if (!section || section.dataset.bnHeroInit === 'true') return;
    section.dataset.bnHeroInit = 'true';

    const animated = section.querySelectorAll('.bn-hero__animate');
    const ctaLinks = section.querySelectorAll('[data-bn-hero-cta]');

    if (!prefersReducedMotion() && animated.length && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { root: null, rootMargin: '-60px 0px', threshold: 0 }
      );

      animated.forEach(function (el) {
        observer.observe(el);
      });
    } else {
      animated.forEach(function (el) {
        el.classList.add('is-visible');
      });
    }

    ctaLinks.forEach(function (link) {
      link.addEventListener('click', function (e) {
        const href = link.getAttribute('href');
        if (!href || href.charAt(0) !== '#') return;

        const target = document.querySelector(href);
        if (!target) return;

        e.preventDefault();
        target.scrollIntoView({ behavior: prefersReducedMotion() ? 'auto' : 'smooth', block: 'start' });
        history.replaceState(null, '', href);
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-bn-hero-section]').forEach(initHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    const section = e.target.querySelector('[data-bn-hero-section]') || e.target;
    if (section.matches && section.matches('[data-bn-hero-section]')) {
      section.dataset.bnHeroInit = '';
      initHero(section);
    }
  });
})();
